module.exports = __webpack_public_path__ + "static/media/event_banner406fc066c4e62d5271a32a7a336d07bf.webp";